import { getUrl, Request } from "../../request";

export const getLocationProvinces = () => {
  return Request.get(getUrl("/api/v1/locations/country/"));
};

export const getLocationCities = (country_id) => {
  return Request.get(getUrl("/api/v1/locations/city/"), {
    country_id,
  });
};

export const getCountries = () => {
  return Request.get(getUrl("/api/v1/locations/countries/"));
};

export const getCities = (province_id) => {
  return Request.get(getUrl("/api/v1/locations/cities/"), {
    province_id,
  });
};

export const getRegions = (city_id) => {
  return Request.get(getUrl("/api/v1/locations/region/"), {
    city_id,
  });
};



export const getAddressByUserLocation = ({ lng, lat }) => {
  return Request.get(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&zoom=18&addressdetails=1`);
};